import { Box, Typography } from '@vp/swan'
import { TileGreetingOptionsProps } from '~/app/components/TileGreetingOptions/interface'

export const TileGreetingOptions = ({ children }: TileGreetingOptionsProps) => (
  <Box mt={4}>
    <Typography fontSize="small">{children}</Typography>
  </Box>
)
